module.exports = __webpack_public_path__ + "img/origin_icon.709af5ac.svg";